<template>
  <message-element severity="error" :closable="false">
    * Completa los campos requeridos.
  </message-element>
</template>
